var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.873 9.61c-.179-.244-4.436-5.984-9.873-5.984S.305 9.366.127 9.61a.66.66 0 0 0 0 .779c.178.244 4.436 5.984 9.873 5.984s9.694-5.74 9.873-5.984a.66.66 0 0 0 0-.778M10 15.056c-4.005 0-7.474-3.81-8.5-5.056C2.524 8.753 5.985 4.945 10 4.945c4.005 0 7.473 3.809 8.5 5.055-1.025 1.247-4.486 5.055-8.5 5.055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 6.044A3.96 3.96 0 0 0 6.044 10 3.96 3.96 0 0 0 10 13.956 3.96 3.96 0 0 0 13.956 10 3.96 3.96 0 0 0 10 6.044m0 6.593A2.64 2.64 0 0 1 7.363 10 2.64 2.64 0 0 1 10 7.363 2.64 2.64 0 0 1 12.637 10 2.64 2.64 0 0 1 10 12.637"
  })));
};
export default SvgEye;